export default __webpack_public_path__ + "firstpassLogo.cd94ac79.png";